import { render } from "./visitorsArticlesDetails.vue?vue&type=template&id=bb8334b2"
import script from "./visitorsArticlesDetails.vue?vue&type=script&lang=js"
export * from "./visitorsArticlesDetails.vue?vue&type=script&lang=js"

import "./visitorsArticlesDetails.vue?vue&type=style&index=0&id=bb8334b2&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__